import { mount } from "svelte";
import App from './App.svelte';

const { page = "home" } = window.client || {};

mount(App, { target: document.body, props: { page } });